import { DataFarmType } from 'src/app/domainObjects/dataFarmType';
import { PreviewDataImportRequest } from 'src/app/messaging/previewImportDataRequest';
import { ConfigService } from 'src/app/services/config/config.service';
import { DataFarmViewModel } from 'src/app/viewModels/dataFarmViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { TransformerViewModel } from '../../../transformer-list/transformer-list.component';
import { ColumnFilter } from 'src/app/domainObjects/columnFilter';
import { ColumnCalcRuleViewModel } from './columnCalcRuleViewModel';
import { ColumnCalcTransform, ColumnCalcTransformConfig, IfErrorType, IfErrorTypeUtil } from 'src/app/domainObjects/transformers/columnCalcTransform';
import { ColumnCalcPreviewDataResponse } from 'src/app/messaging/columnCalcPreviewDataResponse';
import { OptionItem } from '../../../../model/optionItem';
import { TransformDetailViewModelBase } from '../../../dataTransformConfig/transformers/base/base-transformer-ui/transformDetailViewModelBase';
import { DataDictionaryService } from 'src/app/services/dataDictionary/data-dictionary.service';
import { TransformType } from 'src/app/domainObjects/transformType';
import { TransformerParametersViewModel } from '../transformer-parameters/transformerParametersViewModel';
import { IncludeInfo } from 'src/app/domainObjects/includeInfo';

export enum DataType {
  timestamp,
  integer,
  float,
  string,
  duration
}

export class DataTypeUtil {
  static toString(dataType: DataType): string {
    switch (dataType) {
      case DataType.duration:
        return 'Duration';
      case DataType.integer:
        return 'Integer';
      case DataType.float:
        return 'Float';
      case DataType.string:
        return 'String';
      case DataType.timestamp:
        return 'Timestamp';
    }
  }
}

export class ColumnCalcViewModel extends TransformDetailViewModelBase<ColumnCalcTransform> {
    farmType: DataFarmType;
    runAll: boolean;
    rules: Array<ColumnCalcRuleViewModel> = [];
    parameters:TransformerParametersViewModel;
    dataFarm: DataFarmViewModel;

    ifErrorTypes = [
      new OptionItem(IfErrorType.fail, IfErrorTypeUtil.toString(IfErrorType.fail)),
      new OptionItem(IfErrorType.null, IfErrorTypeUtil.toString(IfErrorType.null)),
      new OptionItem(IfErrorType.zero, IfErrorTypeUtil.toString(IfErrorType.zero))
    ];

    targetDataTypes = [
      new OptionItem(DataType.string, DataTypeUtil.toString(DataType.string)),
      new OptionItem(DataType.integer, DataTypeUtil.toString(DataType.integer)),
      new OptionItem(DataType.float, DataTypeUtil.toString(DataType.float)),
      new OptionItem(DataType.timestamp, DataTypeUtil.toString(DataType.timestamp)),
      new OptionItem(DataType.duration, DataTypeUtil.toString(DataType.duration))
    ];
  
    // Preview options
    rows: number;
    sampleStart: number;
    sampleEnd: number;
  
    isTransformRunning = false;
  
    // Status
    groupHitCount?: number;
    hitCount: number;
    missCount: number;
    hitRatio: number;
    hitRatioDisplay: string;
  
    dataFarms: Array<DataFarmViewModel>;
  
    targetColumns: Array<string>;
  
    request: PreviewDataImportRequest;
    response: ColumnCalcPreviewDataResponse;
  
    constructor(
      dataDictService: DataDictionaryService,
      private configService: ConfigService,
      configViewModel: DataTransformConfigViewModel,
      transformViewModel: TransformerViewModel) {
        
        super(dataDictService, configViewModel, transformViewModel);

        const transformConfig = this.transform.transformConfig;
        this.parameters=new TransformerParametersViewModel();
        if (transformConfig) {
          this.farmType = transformConfig.farmType ?? transformViewModel.transform.dataFarmType;
          this.sampleEnd = transformConfig.sampleEnd + 1;
          this.sampleStart = transformConfig.sampleStart + 1;
          this.runAll = transformConfig.runAll;
          this.sortInfo = transformConfig.sortInfo;
          if(transformConfig.includeInResults){
            this.includeInResults = transformConfig.includeInResults.map(item =>new IncludeInfo(item));
            this.parameters.includeInResults=this.includeInResults;
          }
          //parameters
          this.parameters.sortInfo= transformConfig.sortInfo;
          this.parameters.sampleStart = transformConfig.sampleStart+ 1;
          this.parameters.sampleEnd = transformConfig.sampleEnd+ 1;
          this.parameters.runAll= transformConfig.runAll;

          if (transformConfig.rules) {
            this.rules = transformConfig.rules.map(r => new ColumnCalcRuleViewModel(r));
          }
        }
    }
    
    reindexRules(): void {
      for (let i = 0; i < this.rules.length; i++) {
        this.rules[i].index = i + 1;
      }
      this.rules.sort((a, b) => a.index - b.index);
    }

    override onTransformRunCompleted(response: ColumnCalcPreviewDataResponse): void {
      // Clear
      // this.hitCount = null;
      // this.hitRatio = null;
      // this.missCount = null;
      // this.rows = 0;
      // Clear all stats prior to rebinding new values
     this.rules.forEach( r => {
        r.result = "";
        r.details = "";
      });

      // if (
      //   !response?.previewStats ||
      //   !response?.totalStats ||
      //   !response.totalStats.globalStat ||
      //   //!response.totalStats.ruleStats ||
      //   !response.previewStats.globalStat
      //   //!response.previewStats.ruleStats
      // ) {
      //   return;
      // }
      
      // if (this.runAll) {
      //   // Map Transform Global and Rule stats
      //   this.hitCount = response.totalStats?.globalStat.rowHits;
        
      //   if (response.totalStats?.globalStat.hitRate) {
      //     this.hitRatio = response.totalStats.globalStat.hitRate;
      //     this.hitRatioDisplay = `${(this.hitRatio * 100).toFixed(2)}%`;
      //   }
      //   this.missCount = response.totalStats?.globalStat.rowMisses;
      // } else {
      //   // Map Transform Global and Rule stats
      //   this.hitCount = response.previewStats.globalStat.rowHits;
        
      //   if (response.previewStats.globalStat.hitRate) {
      //     this.hitRatio = response.previewStats.globalStat.hitRate;
      //     this.hitRatioDisplay = `${(this.hitRatio * 100).toFixed(2)}%`;
      //   }
      //   this.missCount = response.previewStats.globalStat.rowMisses;
      // }

      // this.rows = this.runAll ? response.currentData?.totalRows : response.activeData?.totalRows;
      // map the rule stats to the rule
      if (response.totalStats.ruleStats) {
        for (let i = 0; i < this.rules.length; i++) {
          let ruleStats = response.totalStats.ruleStats.find(r => r.ruleIndex === i);
          this.rules[i].result = ruleStats?.rulePassFail;
          this.rules[i].details = ruleStats?.ruleDetails;
        }
      }
    }

    override toTransformConfig(): ColumnCalcTransformConfig {
      const config = new ColumnCalcTransformConfig();
      config.farmType = this.farmType;
      config.transformType = TransformType.columnCalc;
      if(this.parameters.sortInfo){
        if(this.parameters.sortInfo.length==0){
          config.sortInfo =undefined;
        }else{
          config.sortInfo=this.parameters.sortInfo;
        }
      }
      if(this.parameters.includeInResults){
        if(this.parameters.includeInResults.length==0){
          config.includeInResults =undefined;
        }else{
          config.includeInResults =this.parameters.includeInResults.map(item => item.includeField);
        }
      }
      config.sampleStart =this.parameters.sampleStart-1;
      config.sampleEnd =this.parameters.sampleEnd-1;
      config.runAll=this.parameters.runAll;

      config.rules = this.rules.map(r => {
        return r.toRule();
      });

      return config;
    }
  }
  